import { render, staticRenderFns } from "./submitted.vue?vue&type=template&id=171b5b95&"
import script from "./submitted.vue?vue&type=script&lang=js&"
export * from "./submitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports